﻿import Alpine from "alpinejs";
import { SloganContext } from "./slogans/slogan.context";
import { EventBus } from "./bus/event.bus";
import { GraphicsApp } from "./graphics/graphics.app";
import { ProfitableChart } from "./charts/profitable.chart";
import { AccessibilityElement } from "./accessibility/accessibility";
import { DropDown } from "./dropdown";
export const alpine = Alpine;

//import {
//    Swiper
//} from 'swiper';
//import {
//    Navigation,
//    Pagination,
//    Autoplay,
//    EffectFade,
//    EffectCoverflow,
//    Thumbs,
//    Keyboard,
//    Mousewheel,
//    FreeMode
//} from 'swiper/modules';

const slogans = new SloganContext();
const bus = new EventBus();

alpine.store('slogans', {
    newSlogan() { return slogans.get() },
    registerCycles(el: HTMLElement) {
        el.innerText = `-${slogans.get()}`;

        setInterval(ev => {
            el.innerText = `-${slogans.get() }`;
        }, 8000)
    }
});

new ProfitableChart().build();

//const swiper = new Swiper('.swiper', {
//    // Optional parameters
//    modules: [Navigation, Pagination, Autoplay],
//    direction: 'horizontal',
//    loop: true,
//    autoplay: {
//        delay: 3000
//    },
//    // If we need pagination
//    pagination: {
//        el: '.swiper-pagination',
//    },

//    // Navigation arrows
//    navigation: {
//        nextEl: '.swiper-button-next',
//        prevEl: '.swiper-button-prev',
//    },

//    // And if we need scrollbar
//    scrollbar: {
//        el: '.swiper-scrollbar',
//    },
//});

alpine.store('animate', {
    out(id: string) {
        const root = document.body.querySelector(`#${id}`) as HTMLElement;
        root.classList.add('animate-out-top');
        setTimeout(ev => {
            root.remove();
        }, 375)
    },
    register(el: HTMLElement) {
    }
})

alpine.store('contact', {
    copyEmail(el: HTMLButtonElement) {
        navigator.clipboard.writeText("hello@prollygon.com");

        alpine.store('message').addTo(
            el,
            'Email copied'
        )
    }
});

alpine.store('message', {
    list: [],
    addTo(el: HTMLElement, msg: string) {
        const old = el.innerHTML;

        el.innerText = msg;
        el.classList.add('bg-success');

        setTimeout(() => {
            el.innerHTML = old;
            el.classList.remove('bg-success')
        }, 1500);

    },
    add(text: string, duration: number = 1500, cl: string = '') {
        const item = {
            msg: text,
            cl: cl
        };
        
        this.list.push(item);

        setTimeout(() => {
            this.list.splice(this.list.indexOf(item));
        }, duration)
    }
})

alpine.store('menu', {
    showIntro: true,
    measureHeader(el: HTMLElement) {
        const rect = el.getBoundingClientRect();
        const main = document.querySelector('main');
        main.style.marginTop = `${Math.ceil(rect.height)}px`;
    },
    closeIntro() {
        this.showIntro = false;
        
        alpine.nextTick(() => {
            this.updateMain();
        });
    },
    updateMain() {
        const main = document.body.querySelector('main');
        const header = document.body.querySelector('header');
        const rect = header.getBoundingClientRect();
        console.log(header.offsetHeight, header.clientHeight)
        main.style.marginTop = `${rect.height}px`;
    }
});

alpine.store('accessibility', {
    makeMenu(el: HTMLButtonElement) {
        new AccessibilityElement(el)
    }
})

alpine.start();
const graphics = new GraphicsApp();
graphics.run();

const arr = Array.from(document.querySelectorAll('[dropdown]')) as HTMLElement[];

const dropdowns = new Map<string, DropDown>();

arr.forEach(el => {
    const attr = el.getAttribute('dropdown');
    let item: DropDown;

    if (dropdowns.has(attr)) item = dropdowns.get(attr);
    else {
        const dd = new DropDown();

        item = dd;

        dropdowns.set(attr, item);
    }


    if (el.tagName === 'BUTTON' || el.tagName === 'A') {
        item.addTrigger(el as any);
    }
    else item.root = el;
})

window.addEventListener("resize", ev => {
    const el = document.body.querySelector('header');
    const rect = el.getBoundingClientRect();
    const main = document.querySelector('main');
    main.style.marginTop = `${Math.ceil(rect.height)}px`;

});
